import { Component, Input } from '@angular/core';
import { FiltersChannel } from '../../../../filters/models/filters-channel.model';
import { ITileInstance } from '../../../interfaces/tiles/definition-helpers/tile-definition.interface';

@Component({
  standalone: false,
  selector: 'suvo-bi-tile-wrapper',
  templateUrl: './tile-wrapper.component.html',
  styleUrls: ['./tile-wrapper.component.scss'],
})
export class TileWrapperComponent {
  @Input() tileInstance: ITileInstance;
  @Input() filtersChannel?: FiltersChannel;
  @Input() editMode = false;
}
